import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { TableModule } from "primeng/table";
import { SidebarModule } from "primeng/sidebar";
import { DataViewModule } from "primeng/dataview";
import { CalendarModule } from "primeng/calendar";

import { ScanPointComponent } from "./components/scanpoint.component";
import { TimeStampScanningComponent } from "./timestampscanning/time-stamp-scanning.component";
import { ScanPointConfigComponent } from "./scanpointconfig/scan-point-config.component";
import { ScanPointService } from "./services/scanpoint.service";
import { AddHallPassReasonComponent } from "./scanpointconfig/add-hall-pass-reason/add-hall-pass-reason.component";
import { EditHallPassReasonComponent } from "./scanpointconfig/edit-hall-pass-reason/edit-hall-pass-reason.component";
import { ScanEntryComponent } from "./shared/scan-entry/scan-entry.component";
import { SettingsSidebarComponent } from "./shared/settings-sidebar/settings-sidebar.component";
import { ManualSidebarComponent } from "./shared/manual-sidebar/manual-sidebar.component";
import { StudentInfoComponent } from "./shared/manual-sidebar/shared/student-info/student-info.component";
import { SelectorMenuComponent } from "./shared/manual-sidebar/selector-menu/selector-menu.component";
import { AlertMenuComponent } from "./shared/manual-sidebar/alert-menu/alert-menu.component";
import { AttendanceMenuComponent } from "./shared/manual-sidebar/attendance-menu/attendance-menu.component";
import { IDHistoryMenuComponent } from "./shared/manual-sidebar/idhistory-menu/idhistory-menu.component";
import { ScheduleMenuComponent } from "./shared/manual-sidebar/schedule-menu/schedule-menu.component";
import { HallpassMenuComponent } from "./shared/manual-sidebar/hallpass-menu/hallpass-menu.component";
import { AddHallpassComponent } from "./shared/manual-sidebar/hallpass-menu/add-hallpass/add-hallpass.component";
import { UpdateHallpassComponent } from "./shared/manual-sidebar/hallpass-menu/update-hallpass/update-hallpass.component";
import { MarkTimeMenuComponent } from "./shared/manual-sidebar/mark-time-menu/mark-time-menu.component";
import { StaffInfoComponent } from "./shared/manual-sidebar/shared/staff-info/staff-info.component";
import { TimeScanningComponent } from "./time-scanning/time-scanning.component";
import { TimeScanMainAreaComponent } from "./time-scanning/time-scan-main-area/time-scan-main-area.component";
import { TimeScanManualBarComponent } from "./time-scanning/time-scan-manual-bar/time-scan-manual-bar.component";
import { TimeScanSettingsBarComponent } from "./time-scanning/time-scan-settings-bar/time-scan-settings-bar.component";
import { TimeScanningService } from "./time-scanning/shared/data.service";
import { TimeScanEntryComponent } from "./time-scanning/time-scan-main-area/time-scan-entry/time-scan-entry.component";
import { ScanPointManualSelectorComponent } from "./time-scanning/time-scan-manual-bar/scan-point-manual-selector/scan-point-manual-selector.component";
import { ScanPointManualAlertComponent } from "./time-scanning/time-scan-manual-bar/scan-point-manual-alert/scan-point-manual-alert.component";
import { ScanPointManualAttendanceComponent } from "./time-scanning/time-scan-manual-bar/scan-point-manual-attendance/scan-point-manual-attendance.component";
import { ScanPointManualIdHistoryComponent } from "./time-scanning/time-scan-manual-bar/scan-point-manual-id-history/scan-point-manual-id-history.component";
import { ScanPointManualScheduleComponent } from "./time-scanning/time-scan-manual-bar/scan-point-manual-schedule/scan-point-manual-schedule.component";
import { ManualSelectorExtendedInfoComponent } from "./time-scanning/time-scan-manual-bar/scan-point-manual-selector/manual-selector-extended-info/manual-selector-extended-info.component";
import { ScanPointManualMarkTimeComponent } from "./time-scanning/time-scan-manual-bar/scan-point-manual-mark-time/scan-point-manual-mark-time.component";
import { ScanPointManualHallPassComponent } from "./time-scanning/time-scan-manual-bar/scan-point-manual-hall-pass/scan-point-manual-hall-pass.component";
import { ScanPointManualAddHallPassComponent } from "./time-scanning/time-scan-manual-bar/scan-point-manual-hall-pass/scan-point-manual-add-hall-pass/scan-point-manual-add-hall-pass.component";
import { ScanPointManualUpdateHallPassComponent } from "./time-scanning/time-scan-manual-bar/scan-point-manual-hall-pass/scan-point-manual-update-hall-pass/scan-point-manual-update-hall-pass.component";

@NgModule({
	declarations: [
		ScanPointComponent,
		TimeStampScanningComponent,
		ScanPointConfigComponent,
		AddHallPassReasonComponent,
		EditHallPassReasonComponent,
		ScanEntryComponent,
		SettingsSidebarComponent,
		ManualSidebarComponent,
		StudentInfoComponent,
		SelectorMenuComponent,
		AlertMenuComponent,
		AttendanceMenuComponent,
		IDHistoryMenuComponent,
		ScheduleMenuComponent,
		HallpassMenuComponent,
		AddHallpassComponent,
		UpdateHallpassComponent,
		MarkTimeMenuComponent,
		StaffInfoComponent,
		TimeScanningComponent,
		TimeScanMainAreaComponent,
		TimeScanManualBarComponent,
		TimeScanSettingsBarComponent,
		TimeScanEntryComponent,
		ScanPointManualSelectorComponent,
		ScanPointManualAlertComponent,
		ScanPointManualAttendanceComponent,
		ScanPointManualIdHistoryComponent,
		ScanPointManualScheduleComponent,
		ManualSelectorExtendedInfoComponent,
		ScanPointManualMarkTimeComponent,
		ScanPointManualHallPassComponent,
		ScanPointManualAddHallPassComponent,
		ScanPointManualUpdateHallPassComponent,
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		AppSharedModule,
		RouterModule,
		BrowserAnimationsModule,
		ConfirmDialogModule,
		DialogModule,
		DropdownModule,
		TableModule,
		SidebarModule,
		DataViewModule,
		CalendarModule,
	],
	providers: [ScanPointService, TimeScanningService],
})
export class ScanPointModule {}
